import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { GoogleAutoCompleteResponse } from 'src/app/trip-calculator/models/api-response';

@Injectable({
  providedIn: 'root',
})
export class GoogleService {
  private http = inject(HttpClient);

  getAutocomplete(input: string): Observable<GoogleAutoCompleteResponse> {
    const params = new HttpParams().set('input', input);
    return this.http.get<GoogleAutoCompleteResponse>(
      environment.apiUrl + '/address/autocomplete',
      {
        params,
      },
    );
  }
}
